import { connect } from 'react-redux'
import { themeSelector } from '../../../redux/theme/selector'
import { CheckboxFieldClass } from './CheckboxField.component'
// import { withNextInputAutoFocusInput } from 'react-native-formik'

// const CheckboxField = connect(themeSelector)(withNextInputAutoFocusInput(CheckboxFieldClass))
const CheckboxField = connect(themeSelector)(CheckboxFieldClass)

export { CheckboxField }
